import LoadingCircle from '../../assets/icons/Svg'

export default function LoadingModal() {
    return (
        <div className='fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-10'>
            <div className='relative w-[80%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[40%] lg:w-[20%]'>
                <div className='flex flex-col w-full'>
                    <div className='w-full space-y-3 py-5'>
                        <div className='w-full flex justify-center'>
                            <LoadingCircle size={70} color="#AA6833" />
                        </div>
                        <p className='text-[15px] text-center'>
                            Please wait while your file is being exported.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
